import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import '@fontsource/alegreya-sans/400.css';
import '@fontsource/alegreya-sans/400-italic.css';
import '@fontsource/alegreya-sans/500.css';
import '@fontsource/alegreya-sans/700.css';
import '@fontsource/alegreya/400.css';
import '@fontsource/alegreya/400-italic.css';
import '@fontsource/alegreya/700.css';
import '@fontsource/alegreya/700-italic.css';
import '@fontsource/cinzel/400.css';
import '@fontsource/cinzel/600.css';
import '@fontsource/cinzel/700.css';
import './styles.css';
import './theme.css';
import { initOffline } from './offline';
import { setOwnBuild } from './version';

setOwnBuild(import.meta.url);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Notizen bleiben im Cache, damit Notizwechsel sofort wirken
      staleTime: 30_000,
      gcTime: 30 * 60_000,
      refetchOnWindowFocus: false,
      // Offline entscheidet request() selbst (lokale Kopie) – nicht pausieren, wenn der Browser „offline“ meldet
      networkMode: 'always',
      retry: (count, err) => count < 2 && !(err instanceof Error && 'status' in err && (err as { status: number }).status < 500),
    },
    mutations: { networkMode: 'always' },
  },
});

const render = () =>
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>,
  );

// Offline-Start (nur im Build; Service Worker brauchen HTTPS oder localhost)
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => void navigator.serviceWorker.register('/sw.js').catch(() => undefined));
}

// Erst den Stand der lokalen Kopie kennen (gepufferte Änderungen), dann starten
void initOffline(queryClient).finally(render);
